import React, { useState } from 'react';

import classNames from 'classnames';
import Slider from 'react-slick';

import cls from './Carousel.module.css';

export const useCarousel = (sliderRef: React.MutableRefObject<Slider | null>) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        afterChange: (index: number) => setCurrentIndex(index),
        customPaging: (i: number) => (
            <div className={cls.carouselDotWrapper} onClick={() => sliderRef.current?.slickGoTo(i)}>
                <div
                    className={classNames(cls.carouselDot, {
                        [cls.carouselDotActive]: i === currentIndex,
                    })}
                />
            </div>
        ),
    };

    return { settings };
};
